import script from "./DeviceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceSettings.vue?vue&type=script&setup=true&lang=js"

import "./DeviceSettings.vue?vue&type=style&index=0&id=0d3a5bbb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3a5bbb"]])

export default __exports__